
      
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/components/email-verification/assets/common.lang.json', {"email_registered_by_colleague":{"ru_RU":"Пользователь уже зарегистрирован в «{ org }», как { type }","en_US":"The user already has an account with «{ org }», as a { type }"},"owner":{"ru_RU":"управляющий рекрутер","en_US":"owner"},"manager":{"ru_RU":"рекрутер","en_US":"recruiter"},"watcher":{"ru_RU":"заказчик","en_US":"hiring manager"},"email_already_registered":{"ru_RU":"Почта уже занята","en_US":"Email already registered"}}) 
    }
   
      
      export default "src/components/email-verification/assets/common.lang.json"
    